import { render, staticRenderFns } from "./CardActions.vue?vue&type=template&id=0acae74c"
import script from "./CardActions.vue?vue&type=script&lang=js"
export * from "./CardActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports